export default {
  buttons: { done: 'Fertig' },
  title: 'Standort',
};
